import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the GdxDropdownDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GdxDropdownDataProvider {
  data: any = [];
  list: any = [];
  listSearch: any = [];

  constructor(public http: HttpClient) {
    console.log('Hello GdxDropdownDataProvider Provider');
  }

  addData(data){
    this.list = data;
  }

  addDataSearch(data){
    this.listSearch = data;
  }
}



// WEBPACK FOOTER //
// ./src/providers/gdx-dropdown-data/gdx-dropdown-data.ts